import React from 'react';

const Description = () => {
  return (
    <div className="row-span-1 p-4 shadow-lg drop-shadow-xl text-slate-900 bg-slate-100 rounded-xl lg:col-span-4">
      <h2 className="pt-1 pb-2 pl-2 text-3xl font-extrabold leading-tight font-playfair-display">
        Description
      </h2>
      <div className="flex items-start pl-2 m-1">
        <p className="whitespace-pre-wrap text-white-200 sm:text-lg">
          Our book club is an English-speaking community of women in Munich reading thought-provoking literature. 
          We meet once a month to discuss the chosen book and to share and understand our differing opinions as 
          well as get insight into the author and the context of the book. Follow us on Instagram! @munichgirls.bookclub
        </p>
      </div>
    </div>
  );
};

export default Description;